import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const ResolvedIconMobile = (props: SvgProps) => <Svg
  width='18'
  height='14'
  viewBox='0 0 18 14'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M17.3917 1.12397C17.8755 1.61643 17.8685 2.40785 17.376 2.89167L7.19746 12.8917C6.71115 13.3694 5.93171 13.3694 5.4454 12.8917L0.623973 8.15483C0.131517 7.67101 0.124513 6.87959 0.60833 6.38713C1.09215 5.89467 1.88357 5.88767 2.37603 6.37149L6.32143 10.2477L15.624 1.10833C16.1164 0.624513 16.9079 0.631517 17.3917 1.12397Z'
    fill='white' />
</Svg>;

export default ResolvedIconMobile;
